import React, { useState } from 'react'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import { observer } from 'mobx-react'
import { posServiceMobx, voiceServiceMobx } from '@mobxStore'
import { Icon } from '@cps'
import { VoiceServiceContent } from '@pages/menu/modal/VoiceModal/components'
import './index.scss'

interface ISearchModalProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const ServiceRingModal: React.FC<ISearchModalProps> = (props) => {
  const { reject } = props
  const [isVoice, setIsVoice] = useState<boolean>(false)
  const { sendServiceRing, serviceRingDuration } = posServiceMobx

  // 发送服务铃
  const handleSend = () => {
    if (serviceRingDuration > 0) {
      reject()
      return
    }
    sendServiceRing()
    reject()
  }

  return (
    <IonModal
      cssClass='service-ring-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <i className='iconfont icon-close' onClick={reject} />
      </IonHeader>
      <IonContent>
        <div className='service-ring-content'>
          {
            !isVoice && (
              <div className='service-ring-quick'>
                <h3>{i18n.t('menu.youCan')}</h3>
                <div className='btn-send' onClick={handleSend}>
                  <Icon name='huaban2' size={20} />{i18n.t('menu.sendServiceRing')}
                </div>
              </div>
            )
          }
          {
            voiceServiceMobx.isVoiceEnable && (
              <VoiceServiceContent
                className='service-ring-voice'
                type='serviceRing'
                onReject={reject}
                onResult={reject}
                onStart={() => setIsVoice(true)}
              />
            )
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(ServiceRingModal)
